<template>
    <fieldset>
        <b-form-group
                v-for="field in fieldsLookup"
                :key="field.name"
                :label="field.label"
                :label-for="field.name"
                :state="form.errors.has(field.name) ? false : null"
                :invalid-feedback="form.errors.get(field.name)"
        >
            <b-input-group>
                <b-form-input
                        :id="field.name"
                        v-model="form[field.name]"
                        :name="field.name"
                        :state="form.errors.has(field.name) ? false : null"
                        type="number"
                        step="0.001"
                />

                <b-input-group-text slot="append">
                    <span v-html="field.append" />
                </b-input-group-text>
            </b-input-group>
        </b-form-group>
    </fieldset>
</template>
<script>
    import ELEMENTS_FIELDS_LOOKUP from "@/constants/elements_fields_lookup";

    export default {
        name: 'ElementFields',
        props: {
            form: {
            	type: Object,
				required: true
            }
        },
        computed: {
            fieldsLookup() {
                return ELEMENTS_FIELDS_LOOKUP[this.form.type] || [];
            },
        }
    }
</script>
